<p-dialog modal="true" [closable]="false" styleClass="atlas-dialog-m" [focusOnShow]="false" [(visible)]="isVisible">
  <ng-template pTemplate="header">
    {{ 'profiles.search.actions.multiple-profile-invoice-modal.header' | translate | titlecase }}
  </ng-template>
  <div>
    <div class="mb-27 mct-flex mct-row mct-gap-10">
      <div class="mct-flex mct-col">
        <label>{{ 'profiles.search.actions.multiple-profile-invoice-modal.invoice-date-label' | translate | titlecase }}</label>
        <wl-date-selector [(ngModel)]="invoice.InvoiceHeader.InvoiceDate"></wl-date-selector>
      </div>
      <div class="mct-flex mct-col">
        <label>{{ 'profiles.search.actions.multiple-profile-invoice-modal.invoice-date-due-label' | translate | titlecase }}</label>
        <wl-date-selector [(ngModel)]="invoice.InvoiceHeader.DateDue"></wl-date-selector>
      </div>
    </div>
    <div class="mb-27 mct-flex mct-col">
      <label>{{ 'profiles.search.actions.multiple-profile-invoice-modal.invoice-memo-label' | translate | ucfirst }}</label>
      <textarea name="description" [(ngModel)]="invoice.InvoiceHeader.Memo" pInputTextarea></textarea>
    </div>
    <hr class="mb-27" />
    <strong class="mb-27">{{ 'profiles.search.actions.multiple-profile-invoice-modal.line-items' | translate | ucfirst }}</strong>
    <div class="mct-flex mct-col mct-justify-center mct-items-center">
      <p *ngIf="invoice.LineItems?.length <= 0" class="mb-27">
        {{ 'profiles.search.actions.multiple-profile-invoice-modal.no-line-items' | translate | ucfirst }}
      </p>
      <div *ngFor="let lineItem of invoice.LineItems; index as i" [hidden]="lineItem.DeleteLineItem">
        <wl-invoice-line-item
          [invoice]="invoice"
          [invoiceLineItem]="lineItem"
          [allUsers]="allUsers"
          [allRevenueItems]="allRevenueItems"
          (removeClicked)="removeLineItem(i)"
        ></wl-invoice-line-item>
        <hr />
      </div>
      <button pButton type="button" class="atlas-btn atlas-btn-primary mb-27" (click)="addLineItem()">
        {{ 'profiles.search.actions.multiple-profile-invoice-modal.add-line-item' | translate | uppercase }}
      </button>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="mct-flex-gt-md mct-row-gt-md mct-flex-lt-md mct-col-lt-md mct-justify-end mct-items-center mct-gap-10">
      <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="createInvoices()" [disabled]="isCreating">
        {{ 'profiles.search.actions.multiple-profile-invoice-modal.create-invoices-prepend' | translate | uppercase }}
        {{ selectedProfiles.length }}
        {{ 'profiles.search.actions.multiple-profile-invoice-modal.create-invoices-append' | translate | uppercase }}
        <wl-busy [show]="isCreating"></wl-busy>
      </button>
      <cancel-button [label]="'common.cancel' | translate | uppercase" (onClick)="cancel()"> </cancel-button>
    </div>
  </ng-template>
</p-dialog>
